import styled from 'styled-components';
import { getThemeByPath } from '~/utils';

type StartProps = {
  startColor?: ColorThemeKeys;
};

type StopProps = {
  stopColor?: ColorThemeKeys;
};

const handleStartColor = ({
  startColor = 'colors.secondary.main',
}: StartProps) => getThemeByPath(startColor);

const handleStopColor = ({ stopColor = 'colors.primary.main' }: StopProps) =>
  getThemeByPath(stopColor);

export const Start = styled.stop<StartProps>`
  stop-color: ${handleStartColor};
`;

export const Stop = styled.stop<StopProps>`
  stop-color: ${handleStopColor};
`;
